import { BaseFieldModel, IBaseFieldModel } from '../base/blueprint-field-base.model';

export interface IFieldNumberModel extends IBaseFieldModel {
  isRequired: boolean;
  isReadOnly: boolean;
  value: number;
}
export class FieldNumberModel extends BaseFieldModel implements IFieldNumberModel {
  constructor(
    public isRequired: boolean,
    public isReadOnly: boolean,
    public value: number,
  ) {
    super(isRequired, isReadOnly);
  }
}
